define('_views/Fans',[
	'_models/Fan',
	'text!_templates/fans.html',
	'_views/Fan-Single'
],
function(
	FanModel,
	fansTemplate,
	FanView
) {

	return Backbone.View.extend({
		template: _.template(fansTemplate),

		fanCollection: undefined,
		fanOfCollection: undefined,

		events: {
			'click [data-navigation] a' : 'navigate'
		},

		initialize: function() {
			Backstage.Collection.fanCollection.on('add', this.addFan, this);
			Backstage.Collection.fanOfCollection.on('add', this.addFanOf, this);

			Backstage.Events.on('toggle-fan', this.toggleFan, this);
		},

		render: function(){
			this.$el.html(
				this.template()
			);

			Backstage.Collection.fanOfCollection.comparator = function(model) {
				return -model.get('fan_date');
			};

			Backstage.Collection.fanOfCollection.sort();

			Backstage.Collection.fanCollection.each(_.bind(this.addFan, this));
			Backstage.Collection.fanOfCollection.each(_.bind(this.addFanOf, this));

			return this;
		},

		addFanOf: function(model){
			var fanView = new FanView({
				model: model
			});

			var $view = fanView.render().$el.children()
			$view.unwrap();

			this.$el.find('[data-fans-of]').append($view);
			this.updateFanCounts();
		},

		addFan: function(model){
			var fanView = new FanView({
				model: model
			});

			var $view = fanView.render().$el.children();
			$view.unwrap();

			// we're moving stuff out of the view, keep a reference
			// to the elements so we can remove them when the view is.
			fanView.unwrappedChildren = $view;

			if(model.get('newly_created') === true) {
				this.$el.find('[data-fans]').prepend($view);
			} else {
				this.$el.find('[data-fans]').append($view);
			}

			this.updateFanCounts();

		},

		updateFanCounts: function() {
			this.$el.find('[data-fan-count]').text(Backstage.Collection.fanOfCollection.length);
			this.$el.find('[data-fan-of-count]').text(Backstage.Collection.fanCollection.length);
		},

		showSection: function(which) {
			$('[data-section]', this.el).hide();
			$('[data-section="'+which+'"]', this.el).show();
		},

		toggleFan: function() {
			var _this = this;

			// Make sure we have someone who is logged in
			if (!this.model.get('cookie_url')) {
				parent.window.Cargo.Modal.Alert({
					message: "You must be logged in to become a fan.",
					selector: 'html'
				})
				return;
			}

			// Owner of the site
			if (this.model.get('cookie_id') == this.model.get('id')) {
				return;
			}

			// Unfan
			if (this.model.get('is_fan')) {

				var fan_model = Backstage.Collection.fanCollection.findWhere({ 
					site_id : parseInt(this.model.get('id')),
					fan_id : parseInt(this.model.get('cookie_id'))
				});

				fan_model.destroy();

				// Update the default model
				this.model.set('is_fan', false);
				// render star
				Backstage.View.Star.render();

			// Fan
			} else {

				this.has_error = false;

				var f = new FanModel({
					site_id : this.model.get('id'),
					fan_site_url : this.model.get('cookie_url'),
					fan_site_link : this.model.get('cookie_url'),
					fan_image_url : '',
					fan_site_name : this.model.get('cookie_name'),
					newly_created : true
				});

				f.save({}, {
					success: function(model){
						Backstage.Collection.fanCollection.add(model, {
							at: 0
						});

						// update model as fan, render star
						_this.model.set('is_fan', true);
						Backstage.View.Star.render();

					},
					error: function(model,error){
						var error_obj = JSON.parse(error.responseText);
						if(error_obj.message) {

							_this.has_error = true;

							parent.window.Cargo.Modal.Alert({
								message: error_obj.message,
								selector: 'html'
							});
							
						}
					}
				});
				
			}

			this.updateFanCounts();
		},

		navigate: function(e) {
			Backstage.Router.navigate($(e.currentTarget).attr('href'), true);

			return false;
		}

	});

});

